<footer class="theme-footer-five mt-130 md-mt-100">
  <div class="inner-container">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-4">
          <div class="logo"><a [routerLink]="['/']">
            <img src="assets/images/logo/deski_06.svg" alt=""></a>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="title">Find us on Social Media</div>
          <ul class="d-flex justify-content-center social-icon">
            <li *ngFor="let link of social_links">
              <a [routerLink]="['./']"><i [class]="link" aria-hidden="true"></i></a>
            </li>
          </ul>
        </div>
        <div class="col-lg-4">
          <div class="title">We’r always happy to help.</div>
          <div class="text-center"><a [routerLink]="['./']" class="email">ask@jdeski.com</a></div>
        </div>
      </div>
    </div>
  </div> <!-- /.inner-container -->
  <p class="copyright">Copyright @{{date}}
    <a href="https://themeforest.net/user/ib-themes/portfolio" target="_blank">ib-themes</a> inc.
  </p>
</footer>
